// Paramètre de page d'un index, encodé ou non : `livres%5Bpage%5D=` ou
// `livres[page]=`.
const PAGE_PARAM = /^[^=]*(?:%5B|\[)page(?:%5D|\])=/i;

/**
 * Retire les paramètres de page d'une URL de recherche (lien vers la page 1),
 * quelle que soit leur position dans la requête.
 *
 * @param url - URL absolue ou relative
 * @returns La même URL sans paramètre de page, et sans `?` s'il ne reste rien
 */
export function removePageParam(url: string): string {
  const hashIndex = url.indexOf('#');
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const withoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);

  const queryIndex = withoutHash.indexOf('?');
  if (queryIndex === -1) return url;

  const path = withoutHash.slice(0, queryIndex);
  const params = withoutHash
    .slice(queryIndex + 1)
    .split('&')
    .filter((param) => param !== '' && !PAGE_PARAM.test(param));

  return `${path}${params.length > 0 ? `?${params.join('&')}` : ''}${hash}`;
}
